<template>
  <transition name="el-zoom-in-center">
    <el-card v-show="show" class="box-card" style="text-align: left">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>新增工单</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right" type="primary" @click="show = false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form ref="form" :model="form" label-width="110px" style="width: 100%" :rules="rules">
        <el-row>
          <el-col :span="6">
            <el-form-item label="工单号" prop="orderno">
              <el-input v-model="form.orderno" style="width: 90%" clearable placeholder="请输入工单号" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品编码" prop="product_code">
              <el-select style="width:100%" v-model="form.product_code" clearable filterable remote @change="handleProductChange"
                placeholder="请输入产品名称或编码模糊匹配" :remote-method="getProductSelectList" :loading="productSelectLoading">
                <el-option v-for="item in productSelectList" :key="item.product_code" :label="item.product"
                  :value="item.product_code" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="计划生产数量" prop="product_quantity">
              <el-input v-model.number="form.product_quantity" style="width: 90%" clearable placeholder="请输入计划生产数量" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="erp_id" prop="erp_id">
              <el-input v-model="form.erp_id" style="width: 90%" clearable placeholder="请输入erp_id" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="计划生产日期" prop="plan_date">
              <el-date-picker style="width: 90%" v-model="form.plan_date" type="date" value-format="yyyy-MM-dd"
                format="yyyy 年 MM 月 dd 日" clearable placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <!-- 填写具体奖项 -->
        <h4>产品记录</h4>
        <br />
        <el-row>
          <el-col :span="11">
            <el-card shadow="never">
              <el-form ref="productform" :model="productform" label-width="140px" style="width: 80%" :rules="rules">
                <el-form-item label="原料编码" prop="material_code">
                  <el-select v-model="productform.material_code" style="width: 70%" clearable filterable
                    @change="handleMaterialChange" placeholder="请输入原料名称或编码模糊匹配">
                    <el-option v-for="item in materialSelectList" :key="item.material_code" :label="item.material"
                      :value="item.material_code" />
                  </el-select>
                </el-form-item>
                <el-form-item label="原料计划数量" prop="material_quantity">
                  <el-input v-model.number="productform.material_quantity" style="width: 70%" clearable
                    placeholder="请输入原料计划数量" />
                </el-form-item>
                <el-form-item label="原料批次" prop="material_batchno">
                  <el-input v-model.number="productform.material_batchno" style="width: 70%" clearable
                    placeholder="请输入原料批次" />
                </el-form-item>

              </el-form>
              <div style="text-align: center">
                <el-button style="margin-top: 12px" @click="resetForm('productform')">重置</el-button>
                <el-button style="margin-top: 12px" type="primary" @click="productadd('productform')">生成</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="2" style="text-align: center">
            <el-button @click="productadd('productform')" size="medium" style="margin-top: 100px"
              class="el-icon-d-arrow-right" />
          </el-col>
          <el-col :span="11">
            <el-card shadow="never">
              <el-table :data="tablelist" stripe style="width: 100%" height="224">
                <el-table-column prop="material_code" label="原料编码" show-overflow-tooltip />
                <el-table-column prop="material_name" label="原料名称" show-overflow-tooltip />
                <el-table-column prop="material_quantity" label="原料计划数量" min-width="100" />
                <el-table-column prop="material_batchno" label="原料批次" min-width="100" />
                <el-table-column prop="address" label="操作" width="80" fixed="right">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button type="danger" @click.native.prevent="
                        deleteRow(scope.$index, tablelist)
                        ">删除</el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: center">
          <el-button style="margin-top: 12px" type="primary" @click="submitadd('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>
<script>
import { workorderprocessingAdd, } from "@/api/plant";
import { productlist, materiallist } from "@/api/base";
export default {
  props: {
    search: {
      type: Function,
      default: null,
    }
  },
  data() {
    return {
      show: false,
      //产品下拉选择列表
      productSelectLoading: false,
      productSelectList: [],
      // 原料下拉选择列表
      materialSelectList: [],
      form: {
        orderno: null,
        product_code: null,
        product_name: null,
        product_quantity: null,
        erp_id: null,
        plan_date: null,
      },
      productform: {
        material_name: null,
        material_code: null,
        material_quantity: null,
        material_batchno: null,
      },
      // 步骤2表格数据
      tablelist: [],
      rules: {
        orderno: [
          { required: true, message: "请输入工单号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
        ],
        batchno: [
          { required: true, message: "请输入批次号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
        ],
        material_code: [
          { required: true, message: "请选择原料编码", trigger: "blur" },
        ],
        product_code: [
          { required: true, message: "请输入产品编号", trigger: "blur" },
        ],
        product_name: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        plan_date: [
          { required: true, message: "请选择生产日期", trigger: "blur" },
        ],
        material_quantity: [
          { required: true, message: "请输入原料计划数量", trigger: "blur", type: "number" },
        ],
        product_quantity: [
          { required: true, message: "请输入计划生产数量", trigger: "blur", type: "number" },
        ],
      },
    };
  },
  watch: {
    'show': {
      handler(newValue, oldValue) {
        if (newValue) {
          this.resetForm('form');
          this.resetForm('productform');
          this.tablelist = [];
          this.getProductSelectList();
          this.getMaterialSelectList();
        }
      },
      deep: true
    },
  },
  methods: {
    // 获取产品下拉列表
    getProductSelectList(value) {
      if (value !== "") {
        this.productSelectLoading = true;
        setTimeout(() => {
          this.productSelectLoading = false;
          productlist({ productName: value }).then(response => {
            this.productSelectList = response.data.data || [];
            for (var item of this.productSelectList) {
              item.product = item.product_code + " - " + item.product_name;
            }
          });
        }, 200);
      } else {
        this.productSelectList = [];
      }
    },
    handleProductChange(value) {
      this.form.product_name = this.productSelectList.find(item => item.product_code === this.form.product_code)?.product_name || null;
    },
    // 获取原料下拉列表
    getMaterialSelectList() {
      this.materialSelectList = [];
      materiallist().then((response) => {
        this.materialSelectList = response.data || [];
        for (var item of this.materialSelectList) {
          item.material = item.material_code + " - " + item.material_name;
        }
      });
    },
    handleMaterialChange(value) {
      this.productform.material_name = this.materialSelectList.find(item => item.material_code === this.productform.material_code)?.material_name || null;
    },
    // 把产品添加到表格
    productadd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const newProduct = { ...this.productform };
          for (let i = 0; i < this.tablelist.length; i++) {
            // 产品不能重复
            if (this.tablelist[i].material_code == newProduct.material_code) {
              this.tablelist[i].material_quantity += newProduct.material_quantity;
              this.$refs[formName].resetFields();
              return;
            }
          }
          this.tablelist.push(newProduct);
          this.$refs[formName].resetFields();
        }
      });
    },
    // 表格行删除
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // 保存提交
    submitadd(formName) {
      this.$refs[formName].validate((valid) => {
        // 基础表单验证
        if (valid) {
          if (this.tablelist.length == 0) {
            this.$message({
              type: "warning",
              message: "请添加产品",
            });
            return
          }
          const params = { ...this.form, materials: this.tablelist };
          workorderprocessingAdd(params).then((response) => {
            this.$message({
              type: "success",
              message: "添加成功!",
            });
            this.search();
            this.resetForm('form');
            this.resetForm('productform');
            this.tablelist = [];
            this.show = false;
          });
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>